document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const openBtn = document.getElementById('open-btn');
  const cover = document.getElementById('cover');
  const reserve = document.getElementById('reserve-link');
  const btns = [openBtn, cover, reserve];
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (body.classList.contains('menuopen')) {
        body.classList.remove('menuopen');
        body.classList.add('menuclose');
      } else {
        body.classList.remove('menuclose');
        body.classList.add('menuopen');
      }
    }, false);
  });
}, false);

// スライダー
$(function () {
  $('.foot-slider').slick({
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplay: true,
    autoplaySpeed: 500,
    speed: 1000,
    cssEase: 'ease',
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
